import {createStructuredSelector} from "reselect";
import {IDataProps, IExternalProps} from "ui/molecule/resetPassword/ResetPasswordUI";
import {localizationSelector} from "ui/organism/App/selectors";

export default createStructuredSelector<IExternalProps, IDataProps>({
    localization: localizationSelector,
});
